import React from 'react';
import '../styles/Experience.css';

const experience = [
  {
    title: 'Firewall Deployment & Hardening',
    details: [
      'Designed and implemented secure perimeter defenses using Palo Alto and Fortinet firewalls. Services include rule set optimization, SSL decryption, NAT configuration, and security posture audits.',
    ]
  },
  {
    title: 'Remote Access & VPN Solutions',
    details: [
      'Designed secure site-to-site and remote access VPNs using IPsec, IKEv2, and SSL tunnels. Tuned performance and resolved interoperability issues with third-party networks.',
    ]
  },
  {
    title: 'Network Segmentation & Security Architect',
    details: [
      'Architect scalable, secure networks for multi-site organizations. Delivered VLAN segmentation, dynamic routing, high availability, and policy-based QoS tailored to enterprise needs.',
    ]
  },
  {
    title: 'M&A Integration',
    details: [
      'Provide technical leadership during mergers and acquisitions. Integrate disparate environments, hardened endpoints, and streamlined remote access across domains without disrupting operations.',
    ]
  },
  {
    title: 'Legacy Infrastructure Modernization',
    details: [
      'Modernize aging on-prem or hybrid environments to enhance security, reliability, and manageability. ',
      'This includes evaluating existing infrastructure, developing phased upgrade roadmaps, and executing seamless migrations of legacy firewalls, VPNs, and switching hardware — all with minimal operational disruption.',
      'Ideal for organizations seeking to move away from unsupported systems or eliminate technical debt.'
    ]
  }
];

function Experience() {
  return (
    <section className="experience" id="experience">
      <h2>Professional Experience</h2>
      <div className="timeline">
        {experience.map((job, index) => (
          <div className="job" key={index}>
            <h3>{job.title}</h3>
            <ul>
              {job.details.map((d, i) => (
                <li key={i}>{d}</li>
              ))}
            </ul>
          </div>
        ))}
      </div>
    </section>
  );
}

export default Experience;
